import { ComponentPropsWithoutRef, ComponentRef, forwardRef } from "react";

import { Switch as SwitchBase } from "@radix-ui/themes";

// react-form-hook somehow use boolean value for onchange
// but radix switch use event
// so we need to create a custom switch component
interface SwitchProps
  extends Omit<
    ComponentPropsWithoutRef<typeof SwitchBase>,
    "checked" | "onChange" | "value"
  > {
  onChange?: (checked: boolean) => void;
  value?: boolean;
}
type SwitchRef = ComponentRef<typeof SwitchBase>;

const Switch = forwardRef<SwitchRef, SwitchProps>((props, ref) => {
  const { onChange, value, ...switchProps } = props;
  return (
    <SwitchBase
      {...switchProps}
      checked={value}
      onCheckedChange={onChange}
      ref={ref}
    />
  );
});
Switch.displayName = "Switch";

export { Switch, type SwitchProps };
